export default {
  setImage: (state, view, article) => {
    state.app.preload = [];
    state.press.src = view.app.showImage(article.image.src, state.press.resize);
  }
}